module.exports = __webpack_public_path__ + "static/media/SmartBoard-1920x1080-5.1ac9d176.png";